var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isShowModel
    ? _c(
        "Model",
        {
          attrs: {
            form: _vm.form,
            "init-form": _vm.initForm,
            "is-show": _vm.isShowModel,
            fullscreen: "",
            "custom-title": _vm.dialogTitle,
            "save-item": _vm.saveItem,
            "can-submit": _vm.canSubmit,
            "is-hide-footer": "",
            "before-cancel": _vm.onBeforeClose,
            "close-model": _vm.onBeforeClose,
          },
          on: {
            "update:isShow": function ($event) {
              _vm.isShowModel = $event
            },
            "update:is-show": function ($event) {
              _vm.isShowModel = $event
            },
          },
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: !_vm.canSubmit,
                  expression: "!canSubmit",
                },
              ],
            },
            [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.changeTime.visible,
                      expression: "!changeTime.visible",
                    },
                  ],
                },
                [
                  _vm.activeStep < 4
                    ? _c(
                        "el-row",
                        [
                          _c("el-col", { attrs: { span: 20 } }, [
                            _c(
                              "div",
                              { staticClass: "step-wrap" },
                              [
                                _c("div", {
                                  staticClass: "step-bg",
                                  class: "step-" + (_vm.activeStep + 1),
                                }),
                                _vm._v(" "),
                                _c(
                                  "el-steps",
                                  {
                                    attrs: {
                                      active: _vm.activeStep,
                                      space: "25%",
                                    },
                                  },
                                  [
                                    _c("el-step", {
                                      attrs: {
                                        title: _vm.$t(
                                          "doubleWeekPlan.step.targetTheme"
                                        ),
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("el-step", {
                                      attrs: {
                                        title: _vm.$t(
                                          "doubleWeekPlan.step.mainTheme"
                                        ),
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("el-step", {
                                      attrs: {
                                        title: _vm.$t(
                                          "doubleWeekPlan.step.otherTheme"
                                        ),
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("el-step", {
                                      attrs: {
                                        title: _vm.$t(
                                          "doubleWeekPlan.step.routePlan"
                                        ),
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.activeStep == 0
                    ? _c(
                        "div",
                        { staticClass: "step-wrap-1" },
                        [
                          _c(
                            "BoxWrap",
                            { attrs: { "no-title": "" } },
                            [
                              _c(
                                "el-form",
                                {
                                  ref: "stepOneDataForm",
                                  staticClass: "searchGroup",
                                  attrs: {
                                    model: _vm.stepOneDataForm,
                                    size: "small",
                                    rules: _vm.rules,
                                    inline: "",
                                  },
                                },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: _vm.$t("common.date"),
                                        "label-width": _vm.formLabelWidth,
                                        rules: _vm.rules.validateIpt,
                                        prop: "planTaskDate",
                                      },
                                    },
                                    [
                                      _c("el-date-picker", {
                                        attrs: {
                                          clearable: "",
                                          type: "date",
                                          "value-format": "yyyy-MM-dd",
                                          placeholder: _vm.$t(
                                            "sfe.taskList.input.startTimeHolder"
                                          ),
                                          "picker-options": _vm.pickerOptions,
                                        },
                                        model: {
                                          value:
                                            _vm.stepOneDataForm.planTaskDate,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.stepOneDataForm,
                                              "planTaskDate",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "stepOneDataForm.planTaskDate",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: _vm.$t(
                                          "doubleWeekPlan.input.businessObjective"
                                        ),
                                        "label-width": _vm.formLabelWidth,
                                        rules: _vm.rules.validateChoose,
                                        prop: "subjectType",
                                      },
                                    },
                                    [
                                      _c("FormSelect", {
                                        attrs: {
                                          val: _vm.stepOneDataForm.subjectType,
                                          options:
                                            _vm.optConfig.targetTopicType,
                                        },
                                        on: {
                                          "update:val": function ($event) {
                                            return _vm.$set(
                                              _vm.stepOneDataForm,
                                              "subjectType",
                                              $event
                                            )
                                          },
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: _vm.$t(
                                          "doubleWeekPlan.table.PCD"
                                        ),
                                        "label-width": _vm.formLabelWidth,
                                        rules: _vm.rules.validateChoose,
                                        prop: "provinceCode",
                                      },
                                    },
                                    [
                                      _c("FormCascaderBySR", {
                                        attrs: {
                                          "target-form": _vm.stepOneDataForm,
                                          "region-data": _vm.stepOneDataForm,
                                          level: "sr",
                                          "key-list": [
                                            "province",
                                            "provinceCode",
                                            "city",
                                            "cityCode",
                                            "district",
                                            "districtCode",
                                          ],
                                          "region-props": _vm.regionProps,
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-form-item",
                                    {
                                      staticClass: "flexRow",
                                      attrs: {
                                        label: _vm.$t(
                                          "doubleWeekPlan.input.visitTime"
                                        ),
                                        "label-width": _vm.formLabelWidth,
                                        rules: _vm.rules.validateChoose,
                                      },
                                    },
                                    [
                                      _c("RangePick", {
                                        attrs: {
                                          "target-form": _vm.stepOneDataForm,
                                          "key-list": [
                                            "planTaskStartTime",
                                            "planTaskEndTime",
                                          ],
                                          "actual-plan-task-flag":
                                            _vm.actualPlanTaskFlag,
                                          inline: "",
                                          "picker-line": "",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  attrs: { slot: "footer-right" },
                                  slot: "footer-right",
                                },
                                [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { size: "small", type: "primary" },
                                      on: { click: _vm.goNextStep },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("common.next")) +
                                          "\n            "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.activeStep == 1
                    ? _c(
                        "div",
                        [
                          _c(
                            "el-tabs",
                            [
                              _c("el-tab-pane", {
                                attrs: {
                                  label: _vm.getTopicName(_vm.mainSubjectType),
                                  name: "",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "BoxWrap",
                            { attrs: { "no-title": "" } },
                            [
                              _c(
                                "el-form",
                                {
                                  ref: "searchForm",
                                  staticClass: "searchGroup",
                                  attrs: {
                                    model: _vm.searchForm,
                                    size: "small",
                                    inline: "",
                                  },
                                },
                                [
                                  _vm.mainSubjectType == "targetAttainment" ||
                                  _vm.mainSubjectType == "orderCapture"
                                    ? _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: _vm.$t(
                                              "doubleWeekPlan.table.rtlRtmCategory"
                                            ),
                                            "label-width": _vm.formLabelWidth,
                                          },
                                        },
                                        [
                                          _c("FormSelect", {
                                            attrs: {
                                              val: _vm.searchForm
                                                .rtlRtmCategory,
                                              options:
                                                _vm.optConfig.rtmOptions2,
                                            },
                                            on: {
                                              "update:val": function ($event) {
                                                return _vm.$set(
                                                  _vm.searchForm,
                                                  "rtlRtmCategory",
                                                  $event
                                                )
                                              },
                                            },
                                          }),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.mainSubjectType == "targetAttainment" ||
                                  _vm.mainSubjectType == "orderCapture"
                                    ? _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: _vm.$t(
                                              "doubleWeekPlan.table.retailerType"
                                            ),
                                            "label-width": _vm.formLabelWidth,
                                          },
                                        },
                                        [
                                          _c("FormSelect", {
                                            attrs: {
                                              val: _vm.searchForm.retailerType,
                                              options:
                                                _vm.optConfig
                                                  .storeCategoryOptions2,
                                            },
                                            on: {
                                              "update:val": function ($event) {
                                                return _vm.$set(
                                                  _vm.searchForm,
                                                  "retailerType",
                                                  $event
                                                )
                                              },
                                            },
                                          }),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.mainSubjectType == "targetAttainment" ||
                                  _vm.mainSubjectType == "orderCapture"
                                    ? _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: _vm.$t(
                                              "doubleWeekPlan.table.storeCode"
                                            ),
                                            "label-width": _vm.formLabelWidth,
                                          },
                                        },
                                        [
                                          _c("FormInput", {
                                            attrs: {
                                              val: _vm.searchForm.storeCode,
                                            },
                                            on: {
                                              "update:val": function ($event) {
                                                return _vm.$set(
                                                  _vm.searchForm,
                                                  "storeCode",
                                                  $event
                                                )
                                              },
                                            },
                                          }),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: _vm.$t(
                                          "doubleWeekPlan.table.storeName"
                                        ),
                                        "label-width": _vm.formLabelWidth,
                                      },
                                    },
                                    [
                                      _c("FormInput", {
                                        attrs: {
                                          val: _vm.searchForm.storeName,
                                        },
                                        on: {
                                          "update:val": function ($event) {
                                            return _vm.$set(
                                              _vm.searchForm,
                                              "storeName",
                                              $event
                                            )
                                          },
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _vm.mainSubjectType == "targetAttainment" ||
                                  _vm.mainSubjectType == "orderCapture"
                                    ? _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: _vm.$t(
                                              "doubleWeekPlan.table.contact"
                                            ),
                                            "label-width": _vm.formLabelWidth,
                                          },
                                        },
                                        [
                                          _c("FormInput", {
                                            attrs: {
                                              val: _vm.searchForm.contactor,
                                            },
                                            on: {
                                              "update:val": function ($event) {
                                                return _vm.$set(
                                                  _vm.searchForm,
                                                  "contactor",
                                                  $event
                                                )
                                              },
                                            },
                                          }),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: _vm.$t(
                                          "doubleWeekPlan.table.PCD"
                                        ),
                                        "label-width": _vm.formLabelWidth,
                                      },
                                    },
                                    [
                                      _c("FormCascaderBySR", {
                                        attrs: {
                                          "target-form": _vm.searchForm,
                                          "region-data": _vm.stepOneDataForm,
                                          "key-list": [
                                            "province",
                                            "provinceCode",
                                            "city",
                                            "cityCode",
                                            "district",
                                            "districtCode",
                                          ],
                                          "region-props": _vm.regionProps,
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: _vm.$t(
                                          "doubleWeekPlan.table.storeAddress"
                                        ),
                                        "label-width": _vm.formLabelWidth,
                                      },
                                    },
                                    [
                                      _c("FormInput", {
                                        attrs: {
                                          val: _vm.searchForm.storeAddr,
                                        },
                                        on: {
                                          "update:val": function ($event) {
                                            return _vm.$set(
                                              _vm.searchForm,
                                              "storeAddr",
                                              $event
                                            )
                                          },
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _vm.mainSubjectType == "channelDevelopment"
                                    ? _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: _vm.$t(
                                              "doubleWeekPlan.table.mainBusiness"
                                            ),
                                            "label-width": _vm.formLabelWidth,
                                          },
                                        },
                                        [
                                          _c("FormInput", {
                                            attrs: {
                                              val: _vm.searchForm.mainBusiness,
                                            },
                                            on: {
                                              "update:val": function ($event) {
                                                return _vm.$set(
                                                  _vm.searchForm,
                                                  "mainBusiness",
                                                  $event
                                                )
                                              },
                                            },
                                          }),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.mainSubjectType == "channelDevelopment"
                                    ? _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: _vm.$t(
                                              "doubleWeekPlan.table.storeBrand"
                                            ),
                                            "label-width": _vm.formLabelWidth,
                                          },
                                        },
                                        [
                                          _c("FormInput", {
                                            attrs: {
                                              val: _vm.searchForm
                                                .signBoardBrand,
                                            },
                                            on: {
                                              "update:val": function ($event) {
                                                return _vm.$set(
                                                  _vm.searchForm,
                                                  "signBoardBrand",
                                                  $event
                                                )
                                              },
                                            },
                                          }),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.mainSubjectType == "channelDevelopment"
                                    ? _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: _vm.$t(
                                              "doubleWeekPlan.table.storeType"
                                            ),
                                            "label-width": _vm.formLabelWidth,
                                          },
                                        },
                                        [
                                          _c("FormSelect", {
                                            attrs: {
                                              val: _vm.searchForm.storeType,
                                              options: _vm.optConfig.storeType,
                                            },
                                            on: {
                                              "update:val": function ($event) {
                                                return _vm.$set(
                                                  _vm.searchForm,
                                                  "storeType",
                                                  $event
                                                )
                                              },
                                            },
                                          }),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  attrs: { slot: "footer-right" },
                                  slot: "footer-right",
                                },
                                [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        size: "small",
                                        icon: "el-icon-refresh",
                                      },
                                      on: { click: _vm.resetData },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("common.reset")) +
                                          "\n            "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-button",
                                    {
                                      staticClass: "t-search-btn",
                                      attrs: {
                                        size: "small",
                                        icon: "el-icon-search",
                                      },
                                      on: { click: _vm.searchData },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("common.search")) +
                                          "\n            "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "BoxWrap",
                            {
                              attrs: {
                                "no-title":
                                  _vm.actualPlanTaskFlag !== _vm.PT_STATUS_TASK,
                              },
                            },
                            [
                              _vm.isShowModel
                                ? _c(
                                    "el-table",
                                    {
                                      directives: [
                                        {
                                          name: "loading",
                                          rawName: "v-loading",
                                          value: _vm.table_main.listLoading,
                                          expression: "table_main.listLoading",
                                        },
                                      ],
                                      ref: "table_main",
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        data: _vm.table_main.list,
                                        "row-key": "storeCode",
                                        stripe: "",
                                        border: "",
                                        "highlight-current-row": "",
                                        "tooltip-effect": "dark",
                                        "default-sort": _vm.defaultSort_main,
                                      },
                                      on: {
                                        "selection-change":
                                          _vm.handleStoreCheckedMain,
                                        "sort-change": _vm.sortTable_main,
                                      },
                                    },
                                    [
                                      _c("el-table-column", {
                                        attrs: {
                                          type: "selection",
                                          width: "55",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("el-table-column", {
                                        key: "storeCode",
                                        attrs: {
                                          label: _vm.$t(
                                            "doubleWeekPlan.table.storeCode"
                                          ),
                                          "min-width": "80",
                                          align: "left",
                                          "show-overflow-tooltip": "",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (scope) {
                                                return [
                                                  _vm._v(
                                                    "\n                " +
                                                      _vm._s(
                                                        scope.row.baiLianFlag ==
                                                          "Y"
                                                          ? ""
                                                          : scope.row.storeCode
                                                      ) +
                                                      "\n              "
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          917951871
                                        ),
                                      }),
                                      _vm._v(" "),
                                      _c("el-table-column", {
                                        attrs: {
                                          prop: "storeName",
                                          label: _vm.$t(
                                            "doubleWeekPlan.table.storeName"
                                          ),
                                          "min-width": "180",
                                          align: "left",
                                          "show-overflow-tooltip": "",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("el-table-column", {
                                        attrs: {
                                          prop: "storeAddress",
                                          label: _vm.$t(
                                            "doubleWeekPlan.table.storeAddress"
                                          ),
                                          "min-width": "240",
                                          align: "left",
                                          "show-overflow-tooltip": "",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("el-table-column", {
                                        attrs: {
                                          prop: "contactor",
                                          label: _vm.$t(
                                            "doubleWeekPlan.table.contact"
                                          ),
                                          "min-width": "80",
                                          align: "left",
                                          "show-overflow-tooltip": "",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("el-table-column", {
                                        attrs: {
                                          prop: "phone",
                                          label: _vm.$t(
                                            "doubleWeekPlan.table.contactorPhone"
                                          ),
                                          "min-width": "80",
                                          align: "left",
                                          "show-overflow-tooltip": "",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _vm.mainSubjectType !=
                                      "channelDevelopment"
                                        ? _c("el-table-column", {
                                            key: "tppQty",
                                            attrs: {
                                              prop: "tppQty",
                                              label: _vm.$t(
                                                "doubleWeekPlan.table.tppSales"
                                              ),
                                              "min-width": "80",
                                              align: "left",
                                              "show-overflow-tooltip": "",
                                              sortable: "custom",
                                            },
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.mainSubjectType !=
                                      "channelDevelopment"
                                        ? _c("el-table-column", {
                                            key: "confirmedQty",
                                            attrs: {
                                              prop: "confirmedQty",
                                              label: _vm.$t(
                                                "doubleWeekPlan.table.monthlySverageSales"
                                              ),
                                              "min-width": "80",
                                              align: "left",
                                              "show-overflow-tooltip": "",
                                              sortable: "custom",
                                            },
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c("el-table-column", {
                                        attrs: {
                                          label: _vm.$t(
                                            "doubleWeekPlan.table.otherInformation"
                                          ),
                                          "min-width": "80",
                                          prop: "tag",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (scope) {
                                                return [
                                                  scope.row.assignStore
                                                    ? _c(
                                                        "el-tag",
                                                        {
                                                          attrs: {
                                                            type: "text",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              scope.row
                                                                .assignStore
                                                            )
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  scope.row.visitFrequency
                                                    ? _c(
                                                        "el-tag",
                                                        {
                                                          attrs: {
                                                            type: "text",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              scope.row
                                                                .visitFrequency
                                                            )
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          3093619952
                                        ),
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.table_main.total > 0
                                ? _c("pagination", {
                                    attrs: {
                                      total: _vm.table_main.total,
                                      page: _vm.table_main.currPage,
                                      limit: _vm.table_main.limit,
                                    },
                                    on: {
                                      "update:page": function ($event) {
                                        return _vm.$set(
                                          _vm.table_main,
                                          "currPage",
                                          $event
                                        )
                                      },
                                      "update:limit": function ($event) {
                                        return _vm.$set(
                                          _vm.table_main,
                                          "limit",
                                          $event
                                        )
                                      },
                                      pagination: _vm.queryList,
                                    },
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "footer-right" },
                                [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { size: "small" },
                                      on: {
                                        click: _vm.showBackPreviousStepModel,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("common.back")) +
                                          "\n            "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { size: "small", type: "primary" },
                                      on: { click: _vm.goNextStep },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("common.next")) +
                                          "\n            "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.activeStep == 2
                    ? _c(
                        "div",
                        [
                          _c(
                            "BoxWrap",
                            { attrs: { "no-title": "" } },
                            [
                              _c(
                                "el-form",
                                {
                                  ref: "searchForm",
                                  staticClass: "searchGroup",
                                  attrs: {
                                    model: _vm.searchForm,
                                    size: "small",
                                    inline: "",
                                  },
                                },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: _vm.$t(
                                          "doubleWeekPlan.table.rangeDiameter"
                                        ),
                                        "label-width": _vm.formLabelWidth,
                                      },
                                    },
                                    [
                                      _c("FormSelect", {
                                        attrs: {
                                          val: _vm.searchForm
                                            .distanceBetweenVisits,
                                          options:
                                            _vm.optConfig.distanceBetweenVisits,
                                          change: _vm.queryOtherThemeList,
                                        },
                                        on: {
                                          "update:val": function ($event) {
                                            return _vm.$set(
                                              _vm.searchForm,
                                              "distanceBetweenVisits",
                                              $event
                                            )
                                          },
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-tabs",
                            {
                              on: { "tab-click": _vm.changeOtherSubject },
                              model: {
                                value: _vm.otherSubjectType,
                                callback: function ($$v) {
                                  _vm.otherSubjectType = $$v
                                },
                                expression: "otherSubjectType",
                              },
                            },
                            _vm._l(
                              _vm.otherSubjectList,
                              function (item, index) {
                                return _c("el-tab-pane", {
                                  key: index,
                                  attrs: { label: item.name, name: item.code },
                                })
                              }
                            ),
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "BoxWrap",
                            { attrs: { "no-title": "" } },
                            [
                              _c(
                                "el-form",
                                {
                                  ref: "searchForm",
                                  staticClass: "searchGroup",
                                  attrs: {
                                    model: _vm.searchForm,
                                    size: "small",
                                    inline: "",
                                  },
                                },
                                [
                                  _vm.otherSubjectType == "targetAttainment" ||
                                  _vm.otherSubjectType == "orderCapture"
                                    ? _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: _vm.$t(
                                              "doubleWeekPlan.table.rtlRtmCategory"
                                            ),
                                            "label-width": _vm.formLabelWidth,
                                          },
                                        },
                                        [
                                          _c("FormSelect", {
                                            attrs: {
                                              val: _vm.searchForm
                                                .rtlRtmCategory,
                                              options:
                                                _vm.optConfig.rtmOptions2,
                                            },
                                            on: {
                                              "update:val": function ($event) {
                                                return _vm.$set(
                                                  _vm.searchForm,
                                                  "rtlRtmCategory",
                                                  $event
                                                )
                                              },
                                            },
                                          }),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.otherSubjectType == "targetAttainment" ||
                                  _vm.otherSubjectType == "orderCapture"
                                    ? _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: _vm.$t(
                                              "doubleWeekPlan.table.retailerType"
                                            ),
                                            "label-width": _vm.formLabelWidth,
                                          },
                                        },
                                        [
                                          _c("FormSelect", {
                                            attrs: {
                                              val: _vm.searchForm.retailerType,
                                              options:
                                                _vm.optConfig
                                                  .storeCategoryOptions2,
                                            },
                                            on: {
                                              "update:val": function ($event) {
                                                return _vm.$set(
                                                  _vm.searchForm,
                                                  "retailerType",
                                                  $event
                                                )
                                              },
                                            },
                                          }),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.otherSubjectType == "targetAttainment" ||
                                  _vm.otherSubjectType == "orderCapture"
                                    ? _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: _vm.$t(
                                              "doubleWeekPlan.table.storeCode"
                                            ),
                                            "label-width": _vm.formLabelWidth,
                                          },
                                        },
                                        [
                                          _c("FormInput", {
                                            attrs: {
                                              val: _vm.searchForm.storeCode,
                                            },
                                            on: {
                                              "update:val": function ($event) {
                                                return _vm.$set(
                                                  _vm.searchForm,
                                                  "storeCode",
                                                  $event
                                                )
                                              },
                                            },
                                          }),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.otherSubjectType == "targetAttainment" ||
                                  _vm.otherSubjectType == "orderCapture"
                                    ? _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: _vm.$t(
                                              "doubleWeekPlan.table.storeName"
                                            ),
                                            "label-width": _vm.formLabelWidth,
                                          },
                                        },
                                        [
                                          _c("FormInput", {
                                            attrs: {
                                              val: _vm.searchForm.storeName,
                                            },
                                            on: {
                                              "update:val": function ($event) {
                                                return _vm.$set(
                                                  _vm.searchForm,
                                                  "storeName",
                                                  $event
                                                )
                                              },
                                            },
                                          }),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.otherSubjectType == "targetAttainment" ||
                                  _vm.otherSubjectType == "orderCapture"
                                    ? _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: _vm.$t(
                                              "doubleWeekPlan.table.contact"
                                            ),
                                            "label-width": _vm.formLabelWidth,
                                          },
                                        },
                                        [
                                          _c("FormInput", {
                                            attrs: {
                                              val: _vm.searchForm.contactor,
                                            },
                                            on: {
                                              "update:val": function ($event) {
                                                return _vm.$set(
                                                  _vm.searchForm,
                                                  "contactor",
                                                  $event
                                                )
                                              },
                                            },
                                          }),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: _vm.$t(
                                          "doubleWeekPlan.table.PCD"
                                        ),
                                        "label-width": _vm.formLabelWidth,
                                      },
                                    },
                                    [
                                      _c("FormCascaderBySR", {
                                        attrs: {
                                          "target-form": _vm.searchForm,
                                          "region-data": _vm.stepOneDataForm,
                                          "key-list": [
                                            "province",
                                            "provinceCode",
                                            "city",
                                            "cityCode",
                                            "district",
                                            "districtCode",
                                          ],
                                          "region-props": _vm.regionProps,
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: _vm.$t(
                                          "doubleWeekPlan.table.storeAddress"
                                        ),
                                        "label-width": _vm.formLabelWidth,
                                      },
                                    },
                                    [
                                      _c("FormInput", {
                                        attrs: {
                                          val: _vm.searchForm.storeAddr,
                                        },
                                        on: {
                                          "update:val": function ($event) {
                                            return _vm.$set(
                                              _vm.searchForm,
                                              "storeAddr",
                                              $event
                                            )
                                          },
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _vm.otherSubjectType == "channelDevelopment"
                                    ? _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: _vm.$t(
                                              "doubleWeekPlan.table.mainBusiness"
                                            ),
                                            "label-width": _vm.formLabelWidth,
                                          },
                                        },
                                        [
                                          _c("FormInput", {
                                            attrs: {
                                              val: _vm.searchForm.mainBusiness,
                                            },
                                            on: {
                                              "update:val": function ($event) {
                                                return _vm.$set(
                                                  _vm.searchForm,
                                                  "mainBusiness",
                                                  $event
                                                )
                                              },
                                            },
                                          }),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.otherSubjectType == "channelDevelopment"
                                    ? _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: _vm.$t(
                                              "doubleWeekPlan.table.storeBrand"
                                            ),
                                            "label-width": _vm.formLabelWidth,
                                          },
                                        },
                                        [
                                          _c("FormInput", {
                                            attrs: {
                                              val: _vm.searchForm
                                                .signBoardBrand,
                                            },
                                            on: {
                                              "update:val": function ($event) {
                                                return _vm.$set(
                                                  _vm.searchForm,
                                                  "signBoardBrand",
                                                  $event
                                                )
                                              },
                                            },
                                          }),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.otherSubjectType == "channelDevelopment"
                                    ? _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: _vm.$t(
                                              "doubleWeekPlan.table.storeType"
                                            ),
                                            "label-width": _vm.formLabelWidth,
                                          },
                                        },
                                        [
                                          _c("FormSelect", {
                                            attrs: {
                                              val: _vm.searchForm.storeType,
                                              options: _vm.optConfig.storeType,
                                            },
                                            on: {
                                              "update:val": function ($event) {
                                                return _vm.$set(
                                                  _vm.searchForm,
                                                  "storeType",
                                                  $event
                                                )
                                              },
                                            },
                                          }),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  attrs: { slot: "footer-right" },
                                  slot: "footer-right",
                                },
                                [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        size: "small",
                                        icon: "el-icon-refresh",
                                      },
                                      on: { click: _vm.resetData },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("common.reset")) +
                                          "\n            "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-button",
                                    {
                                      staticClass: "t-search-btn",
                                      attrs: {
                                        size: "small",
                                        icon: "el-icon-search",
                                      },
                                      on: { click: _vm.searchData },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("common.search")) +
                                          "\n            "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "BoxWrap",
                            {
                              attrs: {
                                "no-title":
                                  _vm.actualPlanTaskFlag !== _vm.PT_STATUS_TASK,
                              },
                            },
                            [
                              _vm.isShowModel
                                ? _c(
                                    "el-table",
                                    {
                                      directives: [
                                        {
                                          name: "loading",
                                          rawName: "v-loading",
                                          value: _vm.table_other.listLoading,
                                          expression: "table_other.listLoading",
                                        },
                                      ],
                                      ref: "table_other",
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        data: _vm.table_other.list,
                                        "row-key": "storeCode",
                                        stripe: "",
                                        border: "",
                                        "highlight-current-row": "",
                                        "tooltip-effect": "dark",
                                        "default-sort": _vm.defaultSort_other,
                                      },
                                      on: {
                                        "selection-change":
                                          _vm.handleStoreCheckedOther,
                                        "sort-change": _vm.sortTable_other,
                                      },
                                    },
                                    [
                                      _c("el-table-column", {
                                        attrs: {
                                          type: "selection",
                                          width: "55",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("el-table-column", {
                                        key: "storeCode",
                                        attrs: {
                                          label: _vm.$t(
                                            "doubleWeekPlan.table.storeCode"
                                          ),
                                          "min-width": "80",
                                          align: "left",
                                          "show-overflow-tooltip": "",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (scope) {
                                                return [
                                                  _vm._v(
                                                    "\n                " +
                                                      _vm._s(
                                                        scope.row.baiLianFlag ==
                                                          "Y"
                                                          ? ""
                                                          : scope.row.storeCode
                                                      ) +
                                                      "\n              "
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          917951871
                                        ),
                                      }),
                                      _vm._v(" "),
                                      _c("el-table-column", {
                                        attrs: {
                                          prop: "storeName",
                                          label: _vm.$t(
                                            "doubleWeekPlan.table.storeName"
                                          ),
                                          "min-width": "180",
                                          align: "left",
                                          "show-overflow-tooltip": "",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("el-table-column", {
                                        attrs: {
                                          prop: "storeAddress",
                                          label: _vm.$t(
                                            "doubleWeekPlan.table.storeAddress"
                                          ),
                                          "min-width": "240",
                                          align: "left",
                                          "show-overflow-tooltip": "",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("el-table-column", {
                                        attrs: {
                                          prop: "contactor",
                                          label: _vm.$t(
                                            "doubleWeekPlan.table.contact"
                                          ),
                                          "min-width": "80",
                                          align: "left",
                                          "show-overflow-tooltip": "",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("el-table-column", {
                                        attrs: {
                                          prop: "phone",
                                          label: _vm.$t(
                                            "doubleWeekPlan.table.contactorPhone"
                                          ),
                                          "min-width": "80",
                                          align: "left",
                                          "show-overflow-tooltip": "",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _vm.otherSubjectType !=
                                      "channelDevelopment"
                                        ? _c("el-table-column", {
                                            key: "tppQty",
                                            attrs: {
                                              prop: "tppQty",
                                              label: _vm.$t(
                                                "doubleWeekPlan.table.tppSales"
                                              ),
                                              "min-width": "80",
                                              align: "left",
                                              "show-overflow-tooltip": "",
                                              sortable: "custom",
                                            },
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.otherSubjectType !=
                                      "channelDevelopment"
                                        ? _c("el-table-column", {
                                            key: "confirmedQty",
                                            attrs: {
                                              prop: "confirmedQty",
                                              label: _vm.$t(
                                                "doubleWeekPlan.table.monthlySverageSales"
                                              ),
                                              "min-width": "80",
                                              align: "left",
                                              "show-overflow-tooltip": "",
                                              sortable: "custom",
                                            },
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c("el-table-column", {
                                        attrs: {
                                          label: _vm.$t(
                                            "doubleWeekPlan.table.otherInformation"
                                          ),
                                          "min-width": "80",
                                          prop: "tag",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (scope) {
                                                return [
                                                  scope.row.assignStore
                                                    ? _c(
                                                        "el-tag",
                                                        {
                                                          attrs: {
                                                            type: "text",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              scope.row
                                                                .assignStore
                                                            )
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  scope.row.visitFrequency
                                                    ? _c(
                                                        "el-tag",
                                                        {
                                                          attrs: {
                                                            type: "text",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              scope.row
                                                                .visitFrequency
                                                            )
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          3093619952
                                        ),
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.table_other.total > 0
                                ? _c("pagination", {
                                    attrs: {
                                      total: _vm.table_other.total,
                                      page: _vm.table_other.currPage,
                                      limit: _vm.table_other.limit,
                                    },
                                    on: {
                                      "update:page": function ($event) {
                                        return _vm.$set(
                                          _vm.table_other,
                                          "currPage",
                                          $event
                                        )
                                      },
                                      "update:limit": function ($event) {
                                        return _vm.$set(
                                          _vm.table_other,
                                          "limit",
                                          $event
                                        )
                                      },
                                      pagination: _vm.queryList,
                                    },
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "footer-right" },
                                [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { size: "small" },
                                      on: {
                                        click: _vm.showBackPreviousStepModel,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("common.back")) +
                                          "\n            "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { size: "small", type: "primary" },
                                      on: { click: _vm.goNextStep },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("common.next")) +
                                          "\n            "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.activeStep == 3
                    ? _c(
                        "div",
                        [
                          _c(
                            "BoxWrap",
                            { attrs: { "no-title": "" } },
                            [
                              _c(
                                "el-form",
                                {
                                  ref: "searchForm",
                                  staticClass: "searchGroup",
                                  attrs: {
                                    model: _vm.searchForm,
                                    size: "small",
                                    inline: "",
                                  },
                                },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: _vm.$t(
                                          "doubleWeekPlan.table.firstVisitStore"
                                        ),
                                        "label-width": _vm.formLabelWidth,
                                      },
                                    },
                                    [
                                      _c("FormSelect", {
                                        attrs: {
                                          val: _vm.stepFourDataForm.firstStore,
                                          "label-key": "storeName",
                                          "value-key": "storeCode",
                                          options:
                                            _vm.getAllFirstCheckStoreList(),
                                        },
                                        on: {
                                          "update:val": function ($event) {
                                            return _vm.$set(
                                              _vm.stepFourDataForm,
                                              "firstStore",
                                              $event
                                            )
                                          },
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: _vm.$t(
                                          "doubleWeekPlan.table.endVisitStore"
                                        ),
                                        "label-width": _vm.formLabelWidth,
                                      },
                                    },
                                    [
                                      _c("FormSelect", {
                                        attrs: {
                                          val: _vm.stepFourDataForm.lastStore,
                                          "label-key": "storeName",
                                          "value-key": "storeCode",
                                          options:
                                            _vm.getAllLastCheckStoreList(),
                                        },
                                        on: {
                                          "update:val": function ($event) {
                                            return _vm.$set(
                                              _vm.stepFourDataForm,
                                              "lastStore",
                                              $event
                                            )
                                          },
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "footer-right" },
                                [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { size: "small" },
                                      on: {
                                        click: _vm.showBackPreviousStepModel,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("common.back")) +
                                          "\n            "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { size: "small", type: "primary" },
                                      on: { click: _vm.goNextStep },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("common.next")) +
                                          "\n            "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.activeStep == 4
                    ? _c(
                        "div",
                        [
                          _c(
                            "BoxWrap",
                            {
                              staticClass: "store-plan-preview",
                              attrs: { "no-title": true },
                            },
                            [
                              _c("div", { staticClass: "plan-map-wrap" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "plan-map-content",
                                    attrs: { id: "plan-map-content" },
                                  },
                                  [
                                    _c("PlanMap2", {
                                      ref: "planMap2",
                                      attrs: {
                                        "store-list": _vm.previewStoreList,
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]),
                              _vm._v(" "),
                              _c(
                                "el-table",
                                {
                                  ref: "table_main",
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    data: _vm.previewStoreList,
                                    "row-key": "storeCode",
                                    stripe: "",
                                    border: "",
                                    "highlight-current-row": "",
                                    "tooltip-effect": "dark",
                                  },
                                },
                                [
                                  _c("el-table-column", {
                                    attrs: {
                                      type: "index",
                                      label: _vm.$t(
                                        "doubleWeekPlan.table.planRangeNo"
                                      ),
                                      width: "100",
                                      "show-overflow-tooltip": "",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: _vm.$t(
                                        "doubleWeekPlan.table.planRangeTime"
                                      ),
                                      "min-width": "60",
                                      align: "left",
                                      "show-overflow-tooltip": "",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c(
                                                "el-form",
                                                {
                                                  ref: "dataForm",
                                                  attrs: {
                                                    model: scope.row,
                                                    size: "small",
                                                    inline: "",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "RangePick",
                                                    {
                                                      attrs: {
                                                        disabled: false,
                                                        "target-form":
                                                          scope.row,
                                                        "key-list": [
                                                          "planTaskStartTime",
                                                          "planTaskEndTime",
                                                        ],
                                                        "plan-task-date":
                                                          _vm.stepOneDataForm.planTaskDate.replaceAll(
                                                            "-",
                                                            ""
                                                          ),
                                                        "actual-plan-task-flag":
                                                          _vm.actualPlanTaskFlag,
                                                        "get-exclude-array":
                                                          _vm.getExcludeRange(
                                                            scope.row
                                                          ),
                                                        inline: "",
                                                        "picker-line": "",
                                                        custom: "",
                                                      },
                                                      on: {
                                                        change: function (
                                                          $event
                                                        ) {
                                                          return _vm.onRangeChange(
                                                            scope.row
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          attrs: {
                                                            slot: "custom",
                                                          },
                                                          slot: "custom",
                                                        },
                                                        [
                                                          _vm.hasErrorStore(
                                                            scope.row.storeCode
                                                          )
                                                            ? _c(
                                                                "el-button",
                                                                {
                                                                  staticClass:
                                                                    "text-button-error",
                                                                  attrs: {
                                                                    type: "text",
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      (scope.row
                                                                        .planTaskStartTime ||
                                                                        _vm.$t(
                                                                          "doubleWeekPlan.input.startTime"
                                                                        )) +
                                                                        "-" +
                                                                        (scope
                                                                          .row
                                                                          .planTaskEndTime ||
                                                                          _vm.$t(
                                                                            "doubleWeekPlan.input.endTime"
                                                                          ))
                                                                    )
                                                                  ),
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                          _vm._v(" "),
                                                          !_vm.hasErrorStore(
                                                            scope.row.storeCode
                                                          )
                                                            ? _c(
                                                                "el-button",
                                                                {
                                                                  staticClass:
                                                                    "text-button",
                                                                  attrs: {
                                                                    type: "text",
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      (scope.row
                                                                        .planTaskStartTime ||
                                                                        _vm.$t(
                                                                          "doubleWeekPlan.input.startTime"
                                                                        )) +
                                                                        "-" +
                                                                        (scope
                                                                          .row
                                                                          .planTaskEndTime ||
                                                                          _vm.$t(
                                                                            "doubleWeekPlan.input.endTime"
                                                                          ))
                                                                    )
                                                                  ),
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                        ],
                                                        1
                                                      ),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      916478034
                                    ),
                                  }),
                                  _vm._v(" "),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: _vm.$t(
                                        "doubleWeekPlan.table.storeCode"
                                      ),
                                      "min-width": "60",
                                      align: "left",
                                      "show-overflow-tooltip": "",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _vm._v(
                                                "\n                " +
                                                  _vm._s(
                                                    scope.row.baiLianFlag == "Y"
                                                      ? ""
                                                      : scope.row.storeCode
                                                  ) +
                                                  "\n              "
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      917951871
                                    ),
                                  }),
                                  _vm._v(" "),
                                  _c("el-table-column", {
                                    attrs: {
                                      prop: "storeName",
                                      label: _vm.$t(
                                        "doubleWeekPlan.table.storeName"
                                      ),
                                      "min-width": "100",
                                      align: "left",
                                      "show-overflow-tooltip": "",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("el-table-column", {
                                    attrs: {
                                      prop: "storeAddress",
                                      label: _vm.$t(
                                        "doubleWeekPlan.table.storeAddress"
                                      ),
                                      "min-width": "120",
                                      align: "left",
                                      "show-overflow-tooltip": "",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("el-table-column", {
                                    attrs: {
                                      prop: "contactor",
                                      label: _vm.$t(
                                        "doubleWeekPlan.table.contact"
                                      ),
                                      "min-width": "60",
                                      align: "left",
                                      "show-overflow-tooltip": "",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("el-table-column", {
                                    attrs: {
                                      prop: "storePhone",
                                      label: _vm.$t(
                                        "doubleWeekPlan.table.contactorPhone"
                                      ),
                                      "min-width": "60",
                                      align: "left",
                                      "show-overflow-tooltip": "",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: _vm.$t(
                                        "doubleWeekPlan.table.otherInformation"
                                      ),
                                      "min-width": "60",
                                      prop: "tag",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              scope.row.assignStore
                                                ? _c(
                                                    "el-tag",
                                                    { attrs: { type: "text" } },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          scope.row.assignStore
                                                        )
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              scope.row.visitFrequency
                                                ? _c(
                                                    "el-tag",
                                                    { attrs: { type: "text" } },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          scope.row
                                                            .visitFrequency
                                                        )
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      3093619952
                                    ),
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "footer-right" },
                                [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { size: "small" },
                                      on: { click: _vm.showRePlanningModel },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "doubleWeekPlan.table.rePlanStoreVisits"
                                          )
                                        ) + "\n            "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { size: "small" },
                                      on: {
                                        click: _vm.showBackPreviousStepModel,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("common.back")) +
                                          "\n            "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { size: "small", type: "primary" },
                                      on: { click: _vm.saveTaskItem },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "doubleWeekPlan.table.confirmCreation"
                                          )
                                        ) + "\n            "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "Model",
                    {
                      attrs: {
                        "is-show": _vm.isShowRecommendModel,
                        width: "80vw",
                        "is-show-custom-title-slot": "",
                        "cancel-btn-text": _vm.$t("common.cancel"),
                        "confirm-btn-text": _vm.$t("common.next"),
                        "save-item": _vm.goNextStep,
                      },
                      on: {
                        "update:isShow": function ($event) {
                          _vm.isShowRecommendModel = $event
                        },
                        "update:is-show": function ($event) {
                          _vm.isShowRecommendModel = $event
                        },
                      },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "dialog-title",
                          attrs: { slot: "customTitleSlot" },
                          slot: "customTitleSlot",
                        },
                        [
                          _c("div", { staticClass: "el-dialog__title" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "doubleWeekPlan.table.moreStoreRecommendations"
                                )
                              )
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "el-dialog__subTitle" }, [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm.$t(
                                    "doubleWeekPlan.table.moreStoreRecommendationsFirst"
                                  ) +
                                    this.allStoreCheckList.length +
                                    _vm.$t(
                                      "doubleWeekPlan.table.moreStoreRecommendationsLast"
                                    )
                                ) +
                                "\n          "
                            ),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-table",
                        {
                          directives: [
                            {
                              name: "loading",
                              rawName: "v-loading",
                              value: _vm.table_recommend.listLoading,
                              expression: "table_recommend.listLoading",
                            },
                          ],
                          ref: "table_recommend",
                          staticStyle: { width: "100%" },
                          attrs: {
                            data: _vm.table_recommend.list,
                            "row-key": "storeCode",
                            stripe: "",
                            border: "",
                            "highlight-current-row": "",
                            "tooltip-effect": "dark",
                          },
                          on: {
                            "selection-change": _vm.handleStoreCheckedRecommend,
                          },
                        },
                        [
                          _vm.actualPlanTaskFlag === _vm.PT_STATUS_PLAN
                            ? _c("el-table-column", {
                                attrs: { type: "selection", width: "55" },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              label: _vm.$t("doubleWeekPlan.table.storeCode"),
                              width: "120",
                              align: "left",
                              "show-overflow-tooltip": "",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(
                                            scope.row.baiLianFlag == "Y"
                                              ? ""
                                              : scope.row.storeCode
                                          ) +
                                          "\n            "
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              1599183103
                            ),
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              prop: "storeName",
                              label: _vm.$t("doubleWeekPlan.table.storeName"),
                              "min-width": "180",
                              align: "left",
                              "show-overflow-tooltip": "",
                            },
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              prop: "storeAddress",
                              label: _vm.$t(
                                "doubleWeekPlan.table.storeAddress"
                              ),
                              "min-width": "180",
                              align: "left",
                              "show-overflow-tooltip": "",
                            },
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              prop: "contactor",
                              label: _vm.$t("doubleWeekPlan.table.contact"),
                              width: "120",
                              align: "left",
                              "show-overflow-tooltip": "",
                            },
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              prop: "phone",
                              label: _vm.$t(
                                "doubleWeekPlan.table.contactorPhone"
                              ),
                              width: "120",
                              align: "left",
                              "show-overflow-tooltip": "",
                            },
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              label: _vm.$t(
                                "doubleWeekPlan.table.otherInformation"
                              ),
                              "min-width": "80",
                              prop: "tag",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      scope.row.assignStore
                                        ? _c(
                                            "el-tag",
                                            { attrs: { type: "text" } },
                                            [
                                              _vm._v(
                                                _vm._s(scope.row.assignStore)
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      scope.row.visitFrequency
                                        ? _c(
                                            "el-tag",
                                            { attrs: { type: "text" } },
                                            [
                                              _vm._v(
                                                _vm._s(scope.row.visitFrequency)
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              3093619952
                            ),
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "Model",
            {
              attrs: {
                "is-show": _vm.isShowBackPreviousStepModel,
                "custom-title": _vm.$t("doubleWeekPlan.table.backPreviousStep"),
                "cancel-btn-text": _vm.$t("common.cancel"),
                "confirm-btn-text": _vm.$t("common.confirm"),
                "save-item": _vm.goPreviousStep,
              },
              on: {
                "update:isShow": function ($event) {
                  _vm.isShowBackPreviousStepModel = $event
                },
                "update:is-show": function ($event) {
                  _vm.isShowBackPreviousStepModel = $event
                },
              },
            },
            [
              _c("div", [
                _vm._v(
                  _vm._s(_vm.$t("doubleWeekPlan.table.backPreviousStepTips"))
                ),
              ]),
            ]
          ),
          _vm._v(" "),
          _c(
            "Model",
            {
              attrs: {
                "is-show": _vm.isShowRePlanningModel,
                "custom-title": _vm.$t(
                  "doubleWeekPlan.table.rePlanStoreVisits"
                ),
                "cancel-btn-text": _vm.$t("common.cancel"),
                "confirm-btn-text": _vm.$t("common.confirm"),
                "save-item": _vm.replanTask,
              },
              on: {
                "update:isShow": function ($event) {
                  _vm.isShowRePlanningModel = $event
                },
                "update:is-show": function ($event) {
                  _vm.isShowRePlanningModel = $event
                },
              },
            },
            [
              _c("div", [
                _vm._v(_vm._s(_vm.$t("doubleWeekPlan.table.rePlanningTips"))),
              ]),
            ]
          ),
          _vm._v(" "),
          _c("TimeConflictModel", {
            ref: "timeConflictModel",
            attrs: { "opt-config": _vm.optConfig },
          }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }